/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_DROPDOWN_LEAVE,
  LOAD_LEAVE_DETAILS,
  LOAD_PERMISSION,
  LOAD_LOP,
  LOAD_SETTING,
} from "./constants";

import {
  loadLeaveDetails,
  loadLeaveDetailsSuccess,
  loadLeaveDetailsError,
  loadPermission,
  loadPermissionSuccess,
  loadPermissionError,
  loadLOP,
  loadLOPSuccess,
  loadLOPError,
  loadLeaveDropdownSuccess,
  loadLeaveDropdownError,
  loadSetting,
  loadSettingSuccess,
  loadSettingError
} from "./actions";

import {
  loadLeaveDetailsAPI,
  loadPermissionDetailsAPI,
  loadLOPDetails,
  loadLeaveDropdownAPI,
  loadSettingDetails,
} from "./remotes";

function* loadLeaveDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_LEAVE_DETAILS),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadLeaveDetails(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadLeaveDetailsAPI, searchFilter);
        if (result) {
          yield put(loadLeaveDetailsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadLeaveDetailsError(
            yield put(
              loadLeaveDetailsError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

function* loadPermissionDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PERMISSION),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadPermission(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadPermissionDetailsAPI, searchFilter);
        if (result) {
          yield put(loadPermissionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPermissionError(
            yield put(
              loadPermissionError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

function* loadLOPDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_LOP),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadLOP(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadLOPDetails, searchFilter);
        if (result) {
          yield put(loadLOPSuccess(result));
        }
      } catch (error) {
        yield put(
          loadLOPError(
            yield put(
              loadLOPError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}

function* loadLeaveDropdownSaga() {
  while (true) {
    yield race({
      metaData: take(LOAD_DROPDOWN_LEAVE),
    });

    try {
      const department = yield call(loadLeaveDropdownAPI, "dept", "post");
      const designation = yield call(loadLeaveDropdownAPI, "allDesign", "post");
      const employee = yield call(loadLeaveDropdownAPI, "allemployee", "post", "leave")
      let dropDownList = {
        departmentOptions:
          (department &&
            department.result &&
            department.result.length > 0 &&
            department.result
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.departmentName,
                    value: c._id,

                  }
                )
              )) ||
          [],
        designationOptions:
          (designation &&
            designation.result &&
            designation.result.length > 0 &&
            designation.result
              .filter(f => f.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.designationName,
                    value: c._id,

                  }
                )
              )) ||
          [],
        employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data
              .filter(f => f.status === 1)
              .map((data) =>
                Object.assign(
                  {},
                  {
                    label: `${data.employeeCode} - ${data.employeeName}`,
                    value: data.employeeCode,
                    _id: data._id,
                    departmentName: data.departmentId
                      ? data.departmentId.departmentName
                      : null, // Make sure it has a name
                      departmentId:data.departmentId
                      ? data.departmentId._id
                      : null,
                    designationName: data.designationId
                      ? data.designationId.designationName
                      : null, // Get the designation name
                      designationId: data.designationId
                      ? data.designationId._id
                      : null, // Get the designation name
                    isSl: data.isSl,
                    isCl: data.isCL
                  }
                )
              )) ||
          [],
      };

      yield put(loadLeaveDropdownSuccess(dropDownList));
    } catch (error) {
      yield put(
        loadLeaveDropdownError(
          (error && error.response && error.response.message) ||
          "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

function* loadSettingDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SETTING),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadSetting(explicitLoad));

    if (explicitLoad) {
      try {
        const result = yield call(loadSettingDetails, searchFilter);
        if (result) {
          yield put(loadSettingSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadSettingError(
            yield put(
              loadSettingError(
                (error && error.response && error.response.message) ||
                "Fetch Records Failed"
              )
            )
          )
        );
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadLeaveDetailsSaga(),
    loadPermissionDetailsSaga(),
    loadLOPDetailsSaga(),
    loadLeaveDropdownSaga(),
    loadSettingDetailsSaga()
  ]);
}
